import { ActionType } from "../Action/Types";

const initialState = {
  projectName: "",
  username: "",
};

const detailReducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionType.SET_USER_NAME:
      return { ...state, username: action.payload };

    case ActionType.SET_PROJECT_NAME:
      return { ...state, projectName: action.payload };

    default:
      return state;
  }
};

export default detailReducer;
